angular.module('cvsApp').service('possibleDeliveryDateService', ['networkService', 'xdrService', 'possibleDeliveryDateServiceModel', 'configManager', 'cvsAppData', function(NS, XS, PDDSM, CM,CAD) {

    function possibleDeliveryDateService() {
        this.possibleDeliveryDates = function(callBackSuccess) {
            //get url 
            var url = CM.getAGPAPIUrl('DELIVERYDATES', "", CAD.getTokenType());
            if (url === "URL_ERROR") {

            } else {
                var request = {
                    url: url,
                    header: {
                        "Content-Type": "application/xml",
                        "Accept":"application/xml"
                    },
                    data: getRequestBody(),
                    onSuccess: callBackSuccess
                }
                if (cvsUtility.getIEVersion() <= 9) {
                    XS.makeRequest(url, getRequestBody(), xdrSuccess);

                    function xdrSuccess(data) {
                        PDDSM.setResponse(data);
                        callBackSuccess(PDDSM.getResponse());
                    }
                } else {
                    var possibleDeliveryDatesPromise = NS.post(request);
                    possibleDeliveryDatesPromise.then(function(data, c, d) {
                        // console.log("Data", data.data)
                        PDDSM.setResponse(data.data);
                        callBackSuccess(PDDSM.getResponse());



                    });
                }
            }

        }       

        var getRequestBody = function() {
            var apikey = CAD.getApiKey();
            var reqObj = {
                "possibleDeliveryDatesRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
                            "responseFormat": "XML"
                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                    }                    
                }
            };    
            
            return cvsUtility.JSONToXml(reqObj);

        }
    }

    return new possibleDeliveryDateService();
}]);
